import { configureStore } from "@reduxjs/toolkit";
// settings
import settings from "../features/settings/Slice";

// auth
import auth from "../features/auth/Slice";
import notification from "../features/notification/Slice";
import spin from "../features/spin/Slice";

// common
import common from "../features/admin/common/Slice";

// masters
import masters from "./masters";


import aboutus from "./aboutus.js";

import customers from "./customers";

import usermanagement from "./usermanagement";
import games from "./games";



import subscription from "../features/admin/subscription/slice"
import wallet from "../features/wallet/slice"
import support from "../features/support/slice"


export const store = configureStore({
  reducer: {

    settings: settings,
    //auth
    auth: auth,
    notification: notification,
    //common
    common: common,
    //masters
    masters,
    //aboutus
    aboutus: aboutus,
    //customers
    customers,


    usermanagement,



    subscription: subscription,
    wallet: wallet,

    games,
    support,

    spin: spin,


  },
});
